import { render } from "./ProfileVehicleTable.vue?vue&type=template&id=061cc32b"
import script from "./ProfileVehicleTable.vue?vue&type=script&lang=js"
export * from "./ProfileVehicleTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__